export default __webpack_public_path__ + "static/media/Vidste_du_Frikadeller_1.b89d11c1.mp4";